import Feathers from './feathers'

class Magazine extends Feathers {
    getRelevantArticleList(content,pageNumber,pageSize)
    {
      let url =`${ this.rootPoint }/magazine/article/search?keyword=${encodeURIComponent(content)}&pageIndex=${pageNumber}&pageSize=${pageSize}&sortType=0&searchField=0&slop=100`
      if(!content){
        url = `${ this.rootPoint }/magazine/article/specificLatestUpdates?pageNumber=${pageNumber}&pageSize=${pageSize}`
      }
      return this.request({
            url: url
      })
   }
   getRelevantKeyWords(key){
        let url = `https://dps.qikan.cn/api/search/analyze/${key}`;
        return this.request({
            url: url
        })
    }
    getCatesList () {
        return this.request({
            url: `${ this.base }category/GetAllByKind?kind=2`
        })
    }

    getDailyRecommend () {
        return this.request({
            url: `${ this.base }magazine/recommfull?kind=1&top=4`
        })
    }

    getListByCate (categorycode, pageindex = 1, pagesize = 10) {
        const url = `${ this.base }magazine/bycategory?categorycode=${
        categorycode }&pagesize=${ pagesize }&pageindex=${ pageindex }`
        return this.request({
            url
        })
    }

    searchWord (keyword, pageindex = 1, pagesize = 18) {
        const url = `${ this.base }magazine/search?keyword=${
        keyword }&pagesize=${ pagesize }&pageindex=${ pageindex }`
        return this.request({
            url
        })
    }

    getRankList (kind, top = 10) {
        const url = `${ this.base }magazine/whole/rank?kind=${
        kind }&top=${ top }`
        return this.request({
            url
        })
    }

    getLatestList (top = 10) {
        const url = `${ this.base }magazine/whole/latest?top=${ top }`
        return this.request({
            url
        })
    }

    getDetailInfo (id, year, issue) {
        const url = `${ this.base }magazine/issue?id=${
        id }&year=${ year }&issue=${ issue }`
        return this.request({
            url
        })
    }
    getLatestMagazineInfo (id) {
        const url = `${ this.base }magazine/issue?id=${
        id }`
        return this.request({
            url
        })
    }

    getCatelog (id, year, issue) {
        const url = `${ this.base }magazine/article/catalog?magazineguid=${
        id }&year=${ year }&issue=${ issue }`
        return this.request({
            url
        })
    }

    getPastMagazines (id) {
        const url = `${ this.base }magazine/issues?id=${
        id }`
        return this.request({
            url
        })
    }

    getPastYears (id) {
        const url = `${ this.base }magazine/years?id=${
        id }`
        return this.request({
            url
        })
    }

    getPastYearIssues (id, year) {
        const url = `${ this.base }magazine/issues?id=${
        id }&year=${ year }`
        return this.request({
            url
        })
    }

    getArticle (articleid,token) {
        let url = `${ this.base }magazine/article/fulldetail?id=${
        articleid }`;
        if(token){
          url+=`&token=${token}`
        }
        return this.request({
            url
        })
    }

    getDailyRecommendationFromRecentDays (days=7) {
        let url = `${ this.base }magazine/article/dailyRecommendationFromRecentDays?days=${days}`;
        return this.request({
            url
        })
    }

    getOriginalImgs (id, year, issue, page = 1) {
        const endPage = page + 1
        const url = `${ this.base }magazine/original/ClearImagesURL?id=${
        id }&year=${ year }&issue=${ issue }&startPage=${ page }&endPage=${ endPage }`
        return this.request({
            url
        })
    }

    getOriginalCatelog (id, year, issue, endPage) {
        //const endPage = startPage + 20
        const url = `${ this.base }magazine/original/PreviewImagesURL?id=${
        id }&year=${ year }&issue=${ issue }&startPage=1&endPage=${ endPage }`
        return this.request({
            url
        })
    }

    
    hightSearchArticle(pageNumber,pageSize,sortType,title,titleLogic,content,contentLogic,minDate,minDateLogic,
      maxDate,maxDateLogic,magazineName,magazineNameLogic,year,yearLogic,issue,issueLogic)
    {
      /*https://dspc.dps.qikan.com/api/magazine/article/search?
      pageNumber=1&pageSize=10[&itemCount=][&sortType=][&title=][&titleLogic=]
      [&titlePrecise=][&content=][&contentLogic=][&contentPrecise=][&column=]
      [&=columnLogic][&columnPrecise=][&minDate=][&minDateLogic=][&minDatePrecise=]
      [&maxDate=][&maxDateLogic=][&maxDatePrecise=][&magazineName=][&magazineNameLogic=]
      [&magazineNamePrecise=][&year=][&yearLogic=][&yearPrecise=][&issue=][&issueLogic=]
      [&issuePrecise=][&categoryCode=][&year=2021]*/
      let url =`${ this.base }magazine/article/search?pageNumber=${pageNumber}&pageSize=${pageSize}&sortType=${sortType}`;
      if(title!='title')
      {
         url+=`&title=${title}&titleLogic=${titleLogic}&titlePrecise=1`;
      }
      if(content!='content')
      {
         url+=`&content=${content}&contentLogic=${contentLogic}&contentPrecise=1`;
      }
      if(minDate!='minDate')
      {
         url+=`&minDate=${minDate}&minDateLogic=${minDateLogic}&minDatePrecise=0`;
      }
      if(maxDate!='maxDate')
      {
         url+=`&maxDate=${maxDate}&maxDateLogic=${maxDateLogic}&maxDatePrecise=0`;
      }
      if(magazineName!='magazineName')
      {
         url+=`&magazineName=${magazineName}&magazineNameLogic=${magazineNameLogic}&magazineNamePrecise=1`;
      }
      if(year!="0")
      {
         url+=`&year=${year}&yearLogic=${yearLogic}&yearPrecise=0`;
      }
      if(issue!="0")
      {
         url+=`&issue=${issue}&issueLogic=${issueLogic}&issuePrecise=0`;
      }
      return this.request({
            url: url
      })
   }
}

export default Magazine
